import { render, staticRenderFns } from "./MemberCenterProfile.vue?vue&type=template&id=cca6de5c&scoped=true&"
import script from "./MemberCenterProfile.vue?vue&type=script&lang=js&"
export * from "./MemberCenterProfile.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterProfile.vue?vue&type=style&index=0&id=cca6de5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca6de5c",
  null
  
)

export default component.exports